"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { PiArrowRight, PiPlayCircle } from "react-icons/pi";

export default function CollegeHero({ content, onContentChange, isSelected }: SectionContentProps) {
  const primaryColor = content.colorPalette?.primary || "#1E3A8A";
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const updateContent = (key: string, value: any) => {
    onContentChange?.({ ...content, [key]: value });
  };

  return (
    <div
      className={`relative overflow-hidden py-24 md:py-32 ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{
        fontFamily,
        background: `linear-gradient(135deg, ${primaryColor}08 0%, #ffffff 100%)`,
      }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16">
          {/* Left Column */}
          <div className="flex-1 text-left space-y-6">
            <span className="inline-block py-1.5 px-4 rounded-full bg-blue-50 text-blue-700 text-xs font-bold uppercase tracking-wider">
              <EditableText
                value={content.tag || "Welcome to our College"}
                onChange={(val) => updateContent("tag", val)}
                as="span"
              />
            </span>
            <h1 className="text-4xl md:text-6xl font-extrabold text-slate-900 leading-tight">
              <EditableText
                value={content.title || "Shaping Tomorrow's Leaders"}
                onChange={(val) => updateContent("title", val)}
                as="span"
              />
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed max-w-xl">
              <EditableText
                value={content.subtitle || "World-class education combined with practical experience to prepare you for a successful career."}
                onChange={(val) => updateContent("subtitle", val)}
                as="span"
              />
            </p>

            <div className="flex flex-wrap gap-4 pt-2">
              <a
                href={content.primaryBtnLink || "#explore"}
                className="px-6 py-3 rounded-lg bg-blue-700 hover:bg-blue-800 text-white font-bold text-sm shadow transition-all"
              >
                {content.primaryCta || "Explore Programs"}
              </a>
              <a
                href={content.secondaryBtnLink || "#visit"}
                className="px-6 py-3 rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-50 font-bold text-sm transition-all flex items-center gap-2"
              >
                {content.secondaryCta || "Schedule a Visit"}
                <PiArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Right Column (Hero Image) */}
          <div className="flex-1 w-full max-w-lg md:max-w-none">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3] border-4 border-white bg-slate-100">
              <img
                src={content.imageUrl || "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=1200&h=800&fit=crop"}
                alt="College Campus"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
